import getCurrency from '@/api/queries/getCurrency';
import { useQuery } from '@tanstack/react-query';

const useCurrency = () => {
  const getCurrencyQuery = useQuery({
    queryKey: ['getCurrency'],
    queryFn: () => getCurrency(),
  });

  return {
    currency: getCurrencyQuery.data,
    currencyLoading: getCurrencyQuery.isPending,
  };
};

export default useCurrency;
